<template>
	<div class="mt-4">
		<p class="overline">Rows</p>
		<FieldChoices :includeTitle="false" :question="question" choicesKey="rows"></FieldChoices>
		<p class="overline">Columns</p>
		<FieldChoices :includeTitle="false" :question="question" choicesKey="columns" :includeWidth="true"></FieldChoices>
	</div>
</template>
<script>
	import FieldChoices from "../editorFields/FieldChoices";
	export default {
		name: "FieldMatrix", 
		props: {
			question: {type: Object} 
		},
		components: {
			FieldChoices: FieldChoices
		},
		data: () => {
		},

	}
</script>